import { therapyPlanningAction } from '../../actions/constant';

const {
  EDIT_AUTHORIZATION_PLANNING_REQUEST,
  EDIT_AUTHORIZATION_PLANNING_SUCCESS,
  EDIT_AUTHORIZATION_PLANNING_FAILURE,
  EDIT_AUTHORIZATION_PLANNING_LOADER,
  EDIT_AUTHORIZATION_PLANNING_RESET,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isEditAuth: false,
};

export const editAuthorizationReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case EDIT_AUTHORIZATION_PLANNING_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isEditAuth: true,
      };
    }

    case EDIT_AUTHORIZATION_PLANNING_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isEditAuth: false,
      };
    case EDIT_AUTHORIZATION_PLANNING_LOADER:
      return {
        ...state,
        loading: true,
      };

    case EDIT_AUTHORIZATION_PLANNING_RESET:
      return intitialstate;

    default:
      return state;
  }
};
